import React from 'react';
import cn from 'classnames';

import { Tooltip } from '@components/common';

import { Icons } from '@icons/icons';

import { IFoldPanelTypes } from './FoldPanel.types';

import SpinnerOverlay from '../SpinnerOverlay';

import './FoldPanel.scss';

const FOLDED_WIDTH = '60px';

const FoldPanel = ({
	buttonsComponent = null,
	children,
	classNameBody,
	classNameWrapper,
	isLoading = false,
	isOpen,
	title,
	tooltip,
	togglePanel,
	width,
	isMinWidth = false,
}: IFoldPanelTypes) => {
	const containerClasses = cn('f5gFoldPanel', { [`${classNameWrapper}`]: !!classNameWrapper });

	const bodyClassname = cn('f5gFoldPanelBody', {
		[`${classNameBody}`]: !!classNameBody,
		f5gFoldPanelBodyClose: !isOpen,
	});

	return (
		<div
			className={containerClasses}
			style={{
				width: isOpen ? width : FOLDED_WIDTH,
				minWidth: isMinWidth && isOpen ? width : 'unset',
			}}
		>
			{isLoading && <SpinnerOverlay />}
			<div className='f5gFoldPanelTitle'>
				{isOpen
					&& <div className='f5gFoldPanelTextTitle'>
						{title}
					</div>
				}
				<Tooltip
					content={tooltip}
					isDisabled={!tooltip}
					placement='top'
				>
					<div
						className='f5gFoldPanelIcon'
						onClick={togglePanel}
					>
						{isOpen ? Icons.chevronsLeft() : Icons.chevronsRight()}
					</div>
				</Tooltip>
			</div>
			<div className={bodyClassname}>
				{children}
			</div>
			{isOpen && buttonsComponent}
		</div>
	);
};

export default FoldPanel;
